import { cleanObject } from "../utils/utility";
import actionTypes from "./../constants/actionTypes";
import { getList } from "./formActions";
import _ from "lodash";


const getIndividualValue = (key, value) => {
    if (Array.isArray(value)) {
        let _updatedFields = [];
        const newValue = value.map((data, _index) => {
            const { resultData = {}, newFields = [] } = getIndividualValue(`${key}.${_index}`, value[_index]);
            _updatedFields = [..._updatedFields, ...newFields];
            return resultData;
        }).reduce((accum, value) => ({ ...accum, ...value }));
        return { resultData: newValue, newFields: _updatedFields }
    } else if (value == null || undefined) {
        return {
            resultData: { [key]: value }, newFields: [{
                id: key,
                label: key,
                type: typeof value == "number" ? "number" : "text",
                isSortable: true
            }]
        };
    } else if (typeof value === 'object') {
        const keys = Object.keys(value);
        let _updatedFields = [];
        const newValue = keys.reduce((accum, _key) => {
            const { resultData = {}, newFields = [] } = getIndividualValue(`${key}.${_key}`, value[_key]);
            _updatedFields = [..._updatedFields, ...newFields];
            return { ...accum, ...resultData };
        }, {});
        return { resultData: newValue, newFields: _updatedFields }
    }
    return {
        resultData: { [key]: value }, newFields: [{
            id: key,
            label: key,
            type: typeof value == "number" ? "number" : "text",
            isSortable: true
        }]
    };
}

const formListJson = (formPayload, listPayload, listKey = 'companies', addExtraFields = false) => {
    const { data = {}, meta = {} } = formPayload;
    const { meta: listMeta = {} } = listPayload;
    const resultList = listPayload[listKey] || [];
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;
    let updatedFields = [...fields];
    let fieldsPushed = {};
    const listData = resultList.map((datum, slIndex) => {
        const { additionalInfo = {} } = datum;
        const { companyLink = '', index: companyIndex = [], industry = [], sector = [] } = additionalInfo;
        let rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case 'slNo': {
                    value = slIndex + 1;
                    break;
                }
                case 'moneyControlLink': {
                    value = { value: 'link', link: companyLink };
                    break;
                }
                case 'index': {
                    value = companyIndex.map(ind => ind.name).join(', ');
                    break;
                }
                case 'industry': {
                    value = industry.map(ind => ind.name).join(', ');
                    break;
                }
                case 'sector': {
                    value = sector.map(ind => ind.name).join(', ');
                    break;
                }
                case 'leverages': {
                    value = (datum[field.id] || []).join(', ');
                    break;
                }
                default: value = datum[field.id] || additionalInfo[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});

        if (addExtraFields) {
            const fieldKeys = fields.reduce((accum, field, index) => {
                return { ...accum, [field.id]: true };
            }, {});

            rowData = Object.keys(datum).reduce((accum, key, index) => {
                if (!fieldKeys[key]) {
                    const { resultData = {}, newFields = [] } = getIndividualValue(key, datum[key]);
                    if (!fieldsPushed[key]) {
                        updatedFields = [...updatedFields, ...newFields];
                        fieldsPushed[key] = true;
                    }
                    return { ...accum, ...resultData };
                }
                return { ...accum };
            }, rowData);
        }

        return rowData;
    });
    return { headers: updatedFields, data: listData, meta };
}

export const listStocks = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const listResponse = await getList(requestPayload, "listCompany", "companies");
            const listJson = formListJson(formData, listResponse);
            return dispatch({
                type: actionTypes.STOCKS.STOCK_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
};

export const emptyListStocks = () => {
    try {
        return async (dispatch, getState) => {
            return dispatch({
                type: actionTypes.STOCKS.STOCK_LIST,
                payload: {},
            });
        }
    } catch (error) {
        console.log(error);
    }
}

const formResponsePayload = (key, formJson, resultData) => {
    if (_.isEmpty(resultData)) {
        return {};
    }
    const { data = {}, meta = {} } = formJson;
    const { section = [] } = data;
    const [firstSection = {}] = section;
    const { fields = [] } = firstSection;

    let _resultData = resultData;
    if (key === 'company_validate_list_historyDate') {
        const keys = Object.keys(resultData);
        _resultData = [];
        keys.forEach(key => {
            const list = resultData[key];
            list.forEach(listData => {
                _resultData.push({ date: key, company: listData });
            });
        })
    } else if (key === 'company_validate_list_historyLength') {
        const keys = Object.keys(resultData);
        _resultData = [];
        keys.forEach(key => {
            const list = resultData[key];
            list.forEach(listData => {
                _resultData.push({ length: key, company: listData });
            });
        })
    } else if (key === 'company_validate_list_matchLiveData') {
        _resultData = [];
        const companyList = Array.isArray(resultData) ? resultData : (resultData ? [resultData] : []);
        companyList.forEach(company => {
            const { historyMisMatch = {}, message = '' } = company;
            const misMatchLength = Object.keys(historyMisMatch);
            misMatchLength.forEach(date => {
                _resultData.push({ date, ...company, misMatch: historyMisMatch[date] });
            })
            const { missingDatesByApi = {} } = company;
            if (!_.isEmpty(missingDatesByApi)) {
                _resultData.push({ ...company, misMatch: missingDatesByApi });
            }
        })
    }

    const listData = _resultData.map(datum => {
        const rowData = fields.reduce((accum, field, index) => {
            let value = '';
            switch (field.id) {
                case 'list': {
                    value = datum;
                    break;
                }
                case 'entry1':
                case 'entry2': {
                    const { name = '', companyId = '', nseCode = '', bseCode = '' } = datum[field.id] || {};
                    value = `${name} (${companyId}) ${nseCode ? 'NSE: ' + nseCode : ''} ${bseCode ? 'BSE: ' + bseCode : ''}`
                    break;
                }
                case "companyMeta": {
                    const { name = '', companyId = '', nseCode = '', bseCode = '' } = datum;
                    if (name) {
                        value = name;
                    }
                    if (companyId) {
                        value += `(${companyId}})`;
                    }
                    if (nseCode && bseCode) {
                        value += `[NSE${nseCode}, BSE:${bseCode}]`;
                    }
                    break;
                }
                case 'misMatch': {
                    const data = datum[field.id] || {};
                    if (typeof data !== "string" && !Array.isArray(data)) {
                        if (
                            Object.prototype.hasOwnProperty.call(data, "missingInMc")
                            || Object.prototype.hasOwnProperty.call(data, "missingInUpstox")
                            || Object.prototype.hasOwnProperty.call(data, "missingInMcCount")
                            || Object.prototype.hasOwnProperty.call(data, "missingInUpstoxCount")
                        ) {
                            const {
                                missingInMc = [],
                                missingInUpstox = [],
                                missingInMcCount = missingInMc.length,
                                missingInUpstoxCount = missingInUpstox.length
                            } = data;
                            const missingInMcPreview = (missingInMc || []).slice(0, 5).join(', ');
                            const missingInUpstoxPreview = (missingInUpstox || []).slice(0, 5).join(', ');
                            value = `MissingInMc:${missingInMcCount}${missingInMcPreview ? ` [${missingInMcPreview}${missingInMcCount > 5 ? ', ...' : ''}]` : ''}, MissingInUpstox:${missingInUpstoxCount}${missingInUpstoxPreview ? ` [${missingInUpstoxPreview}${missingInUpstoxCount > 5 ? ', ...' : ''}]` : ''}`;
                            break;
                        }
                        const keys = Object.keys(data);
                        value = keys.map(key => {
                            const { old = '', new: newData = '', upstox = '' } = data[key];
                            return `[${key}]: ${old}/${newData}/${upstox}`
                        }).join(', ');
                    } else if (Array.isArray(data)) {
                        value = data.join(', ');
                    } else {
                        value = data;
                    }
                    break;
                }
                default: value = datum[field.id] || '';
            }
            return { ...accum, [field.id]: value };
        }, {});
        return rowData;
    });
    return { headers: fields, data: listData, meta };
}

export const validateCompany = (requestPayload, formKeyResultMapping) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const listResponse = await getList(requestPayload, "validateCompany");
            const { payload = {} } = listResponse;
            const result = Object.keys(formKeyResultMapping).reduce((accum, key) => {
                return { ...accum, [formKeyResultMapping[key]]: formResponsePayload(key, formJson[key], payload[formKeyResultMapping[key]]) }
            }, {});
            return dispatch({
                type: actionTypes.STOCKS.VALIDATE_STOCK_RESULT,
                payload: result,
            });
        }
    } catch (error) {
        console.log(error);
    }
}

export const applyIndicators = (requestPayload, listFormKey) => {
    try {
        return async (dispatch, getState) => {
            const { forms = {} } = getState();
            const { formJson = {} } = forms;
            const formData = formJson[listFormKey] || {}
            const { companyPayload = {}, indicators = [] } = requestPayload;
            const listResponse = await getList({
                companyPayload, indicators: cleanObject(indicators),
            }, "applyIndicators", "list");

            const { list = [], meta = {} } = listResponse;
            const [firstList = {}] = list;
            const { history = [], } = firstList;

            const listJson = formListJson(formData, { list: history, meta }, "list", true);
            return dispatch({
                type: actionTypes.STOCKS.INDICATOR_LIST,
                payload: listJson,
            });
        }
    } catch (error) {
        console.log(error);
    }
}
